import { Dispatch } from 'react-redux';

import { checkHasUnseenUserNotificationsAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { clearUserNotificationsStateAction } from './actions/ClearUserNotificationsStateAction';
import { deleteUserNotificationAction } from './actions/DeleteUserNotification';
import { getUserNotificationsAction } from './actions/GetUserNotificationsAction';
import { updateLastSeenUserNotificationAction } from './actions/UpdateLastSeenUserNotificationAction';
import { updateUserNotificationsStatusAction } from './actions/UpdateUserNotificationStatusAction';

export class UserNotificationActions {

  constructor(private dispatch: Dispatch<unknown>) { }

  public getUserNotifications(nextPageToken: string) {
    this.dispatch(getUserNotificationsAction(nextPageToken));
  }

  public updateUserNotificationsStatus(ids: string[], readStatus: boolean) {
    this.dispatch(updateUserNotificationsStatusAction(ids, readStatus));
  }

  public deleteUserNotification(id: string) {
    this.dispatch(deleteUserNotificationAction(id));
  }

  public checkHasUnseenUserNotifications() {
    this.dispatch(checkHasUnseenUserNotificationsAction());
  }

  public updateLastSeenUserNotification(lastSeenUserNotificationId: string) {
    this.dispatch(updateLastSeenUserNotificationAction(lastSeenUserNotificationId));
  }

  public clearUserNotificationsState() {
    this.dispatch(clearUserNotificationsStateAction());
  }
}
